@if (header!='') {
  <h2
    [innerHTML]=header
  >
  </h2>
}

<div class="body">
  @if (!messageHtml) {
    <div
      class="message"
      [innerText]="message"
    ></div>
  }

  @if (messageHtml) {
    <div
      class="message"
      [innerHtml]="messageHtml"
    ></div>
  }

  @if (enableInput) {
    <div>
      <form>
        @if (!passwordInput) {
          <input
            #dialogBoxInput
            name="i1"
            autocomplete="off"
            [(ngModel)]=userInput
            [type]="{'password': passwordInput}"
            (keyup.enter)="pressedEnter()"
          >
        }
      </form>
    </div>
  }

  <div class="buttons">
    @for (option of options; track $index) {
      <a
        [attr.href]="option.href?.url"
        [attr.target]="option.href?.target"
      >
        <button
          [className]=option.color
          [class.loading]="buttonSpinners[$index]"
          [routerLink]="option.routerLink"
          (click)="execute(option.callback, $index)"
        >
          <span [innerText]="option.text"></span>
          <motn-spinner></motn-spinner>
        </button>
      </a>
    }
  </div>
</div>
